import script from "./DocAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./DocAudit.vue?vue&type=script&setup=true&lang=js"

import "./DocAudit.vue?vue&type=style&index=0&id=786738d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786738d4"]])

export default __exports__